module.exports = __webpack_public_path__ + "img/tepetlaoxtoc.cfd1dd04.jpg";